<template>
  <el-form
    :model="member"
    :rules="rules"
    ref="register"
    label-width="80px"
    class="ms-content"
  >
    <el-form-item prop="username" label="用户名">
      <el-input v-model="member.username" placeholder="用户名">
        <!-- <el-button slot="prepend"></el-button> -->
      </el-input>
    </el-form-item>
    <el-form-item prop="password1" label="密码">
      <el-input type="password" placeholder="密码" v-model="member.password1">
        <!-- <el-button slot="prepend"></el-button> -->
      </el-input>
    </el-form-item>
    <el-form-item prop="password" label="确认密码">
      <el-input
        type="password"
        placeholder="确认密码"
        v-model="member.password"
        @keyup.enter.native="submitForm()"
      >
        <!-- <el-button slot="prepend"></el-button> -->
      </el-input>
    </el-form-item>
    <div class="login-btn" style="">
      <el-button :loading="loading" type="primary" @click="submitForm()"
        >注册</el-button
      >
    </div>
    <!-- <p class="login-tips">Tips : 用户名和密码随便填。</p> -->
  </el-form>
</template>

<script>
import { register } from "../api/login";
// import cookie from 'js-cookie'
export default {
  data: function () {
    return {
      queryData: this.$route.query,
      member: {
        username: "",
        password1: "",
        password: ""
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password1: [{ required: true, message: "请输入密码", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      loading: false,
    };
  },
  mounted() {
    console.log(this.queryData)
  },
  methods: {
    submitForm() {
      this.$refs.register.validate((valid) => {
        if (valid) {
          if (this.member.password1 != this.member.password) {
            this.$message.error("密码输入不一致");
            return false;
          }

          register({
            username: this.member.username,
            password: this.member.password
          }).then(res => {
            this.$message.success("注册成功，请登录!");

            this.$emit('registerFlag', true)
          }).catch(err => {
            this.$message.error("注册失败，请稍后再试");
          })

          this.loading = true;

        } else {
          this.$message.error("请输入账号和密码");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.login-btn {
  text-align: center;
  float: center;
}
.login-btn button {
  width: 80px;
  height: 36px;
  margin-bottom: 10px;
}
</style>